// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 225) return "static/chunks/225-57671f315ae3f6d7.js";
	if (chunkId === 167) return "static/chunks/167-52ceb51901841c11.js";
	if (chunkId === 484) return "static/chunks/484-26ab3b93c2bfa1d9.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"384":"fe5752fc684dd0a0","496":"83edc8afc0370428","788":"a3ac66fad89fcf34"}[chunkId] + ".js";
};